export default __webpack_public_path__ + "static/providers-c9acb5a8601037b2c394df65d7b1fe48.png";